import('./components/go-to-by-scroll');

/**
 * ON DOCUMENT READY
 */

(function ($) {

	import('./components/bind-link-to-item');

	import('./components/check-scroll');

	import('./components/toggle-menu');

	import('./components/slideshows');

	import('./components/smooth-scroll');

	import('./components/custom-cursor');

	import('./components/theme-scripts');

})(jQuery);